var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletecrm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6555 2.8125H8.84297V1.875C8.84297 1.35938 8.42109 0.9375 7.90547 0.9375H5.09297C4.57734 0.9375 4.15547 1.35938 4.15547 1.875V2.8125H1.34297C0.724219 2.8125 0.724219 3.75 1.34297 3.75H1.83047L2.23828 12.7219C2.27109 13.4766 2.88984 14.0625 3.64453 14.0625H9.35391C10.1086 14.0625 10.7227 13.4719 10.7602 12.7219L11.168 3.75H11.6555C12.2742 3.75 12.2742 2.8125 11.6555 2.8125ZM5.09297 1.875H7.90547V2.8125H5.09297V1.875ZM9.82266 12.675C9.81328 12.9281 9.60703 13.125 9.35391 13.125H3.64453C3.39141 13.125 3.18984 12.9281 3.17578 12.6797L2.76797 3.75H10.2258L9.81797 12.675H9.82266Z",
    fill: "#FF4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletecrm);
export default __webpack_public_path__ + "static/media/deletecrm.85d0a74f97e31abbd8068219c5f54e34.svg";
export { ForwardRef as ReactComponent };